import { render, staticRenderFns } from "./DtSolicitacoes.vue?vue&type=template&id=ce75d918&scoped=true"
import script from "./DtSolicitacoes.vue?vue&type=script&lang=js"
export * from "./DtSolicitacoes.vue?vue&type=script&lang=js"
import style0 from "./DtSolicitacoes.vue?vue&type=style&index=0&id=ce75d918&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce75d918",
  null
  
)

export default component.exports